import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function setCustomerAddress(
    reference: string | undefined,
    address: ShopTypes.AddressDetails,
) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop
        .post(getUrl(`/baskets/${reference}/update/customeraddress`), {
            json: address,
        })
        .json<ShopTypes.BasketResponse>();
}
